var _mask, _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V24C34 29.5228 29.5228 34 24 34H10C4.47715 34 0 29.5228 0 24V10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V24C34 29.5228 29.5228 34 24 34H10C4.47715 34 0 29.5228 0 24V10Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.5H24V-1.5H10V1.5ZM32.5 10V24H35.5V10H32.5ZM24 32.5H10V35.5H24V32.5ZM1.5 24V10H-1.5V24H1.5ZM10 32.5C5.30558 32.5 1.5 28.6944 1.5 24H-1.5C-1.5 30.3513 3.64872 35.5 10 35.5V32.5ZM10 -1.5C3.64873 -1.5 -1.5 3.64872 -1.5 10H1.5C1.5 5.30558 5.30558 1.5 10 1.5V-1.5ZM32.5 24C32.5 28.6944 28.6944 32.5 24 32.5V35.5C30.3513 35.5 35.5 30.3513 35.5 24H32.5ZM24 1.5C28.6944 1.5 32.5 5.30558 32.5 10H35.5C35.5 3.64873 30.3513 -1.5 24 -1.5V1.5Z",
    fill: "white",
    mask: "url(#path-1-inside-1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8106 9.23976L12.3158 9.7311C12.1613 9.88574 12.0762 10.0915 12.0762 10.3114C12.0762 10.5311 12.1613 10.7371 12.3158 10.8917L17.921 16.4966L12.3096 22.108C12.1551 22.2624 12.0701 22.4684 12.0701 22.6882C12.0701 22.9079 12.1551 23.114 12.3096 23.2685L12.8013 23.76C13.1211 24.08 13.6419 24.08 13.9617 23.76L20.6667 17.079C20.8211 16.9246 20.9299 16.7188 20.9299 16.4971L20.9299 16.4946C20.9299 16.2747 20.821 16.069 20.6667 15.9146L13.9798 9.23976C13.8254 9.08512 13.6135 9.00024 13.3937 9C13.1739 9 12.9648 9.08512 12.8106 9.23976Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 24,
    width: 15,
    height: 15,
    rx: 7.5,
    transform: "rotate(-90 9 24)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/Right Arrow.97e049ba7ec1f04e2be3a6881ce2a181.svg";
export { ForwardRef as ReactComponent };